import { getEnv } from '~/utils/env';

export const getJobsBusinessUnitUrlPath = (businessUnit: string) => `/${businessUnit.toLowerCase()}`;

export const getJobsUrl = () => getEnv('NEXT_PUBLIC_JOBS_WEBSITE_URL', 'http://localhost:3000');

export const getJobsBusinessUnitUrl = (businessUnit: string) =>
  `${getJobsUrl()}${getJobsBusinessUnitUrlPath(businessUnit)}`;

export const getJobsBusinessUnitApiUrl = (businessUnit: string, path: string) =>
  `${getJobsUrl()}/api/${businessUnit.toLowerCase()}/${path}`;

export const getJobsBusinessUnitApiAcquisitionUrl = (businessUnit: string, functionName: string) =>
  `${getJobsBusinessUnitApiUrl(businessUnit, 'acquisition')}/${functionName}`;

export const getJobsBusinessUnitApiAddressUrl = (businessUnit: string, functionName: string) =>
  `${getJobsBusinessUnitApiUrl(businessUnit, 'address')}/${functionName}`;

export const getJobsBusinessUnitApiIndexerUrl = (businessUnit: string, path: string) =>
  `${getJobsBusinessUnitApiUrl(businessUnit, 'indexer')}/${path}`;

export const getJobsBusinessUnitApiParseUrl = (businessUnit: string, functionName: string) =>
  `${getJobsBusinessUnitApiUrl(businessUnit, 'functions')}/${functionName}`;
